import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material';
import { ProductsService } from '../../../../_services/admin/products.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  productList: any[] = [];
  tempProductList: any[] = [];
  imageurl = environment.productImageUrl;

  constructor(private productsService: ProductsService,
    private myTitle: Title,
    private router: Router,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.myTitle.setTitle('Products | ' + environment.commonTitle);
    this.getAllProduct();
  }

  addproduct() {
    this.router.navigate(['/secure/home/product/add-product']);
  }

  getAllProduct() {
    this.productsService.getAllProducts().subscribe(result => {
      if (result.data) {
        this.productList = result.data;
        this.tempProductList = [...this.productList];
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.tempProductList.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.productList = temp;
  }

  deleteProduct(id: number) {
    Swal({
      title: 'Are you sure you want to remove product?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      focusConfirm: false
    }).then((res) => {
      if (res.value) {
        this.productsService.deleteProduct(id).subscribe(result => {
          if (result.data) {
            this.openSnackBar('Product deleted succcessfully.', 'Success');
            this.getAllProduct();
            // const indexRemove = this.productList.findIndex(d => d.id === id);
          } else {
            this.openSnackBar('Fail to delete product.', 'Error!');
          }
        }, error => {
          console.log(error);
          this.openSnackBar(error.error, 'Error!');
        });
      } else if (res.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  editProduct(id: any) {
    this.router.navigate(['/secure/home/product/edit-product/' + id]);
  }

  redirectToProductImages(id: any) {
    this.router.navigate(['/secure/home/product/product-images/' + id]);
  }
}
